import { useState, useEffect } from 'react';
// react components using css transitions for appearing/dissappearing have a tricky behaviour
// when appearing, component should render completely first before applying the styling that has the transition
// when dissappearing, component should continue to be rendered to wait for transition to end
function useRenderTransition(active, transitionDuration) {
    var _a = useState(active), isVisible = _a[0], setIsVisible = _a[1];
    useEffect(function () {
        var id = null;
        if (active)
            setIsVisible(true);
        else {
            id = setTimeout(function () { return setIsVisible(false); }, transitionDuration);
        }
        return function () { return clearTimeout(id); };
    }, [active]);
    var shouldRender = active || isVisible;
    var shouldApplyTransition = active && isVisible;
    return { shouldRender: shouldRender, shouldApplyTransition: shouldApplyTransition };
}
export default useRenderTransition;
